var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.747,
    height: 50.139,
    viewBox: "0 0 39.747 50.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "np_lock_4222614_000000",
    x: 0,
    y: 0,
    width: 39.747,
    height: 50.139,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    transform: "translate(6789.874 -9264.931)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 10,
    height: 13,
    transform: "translate(-6775 9287)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6789.87, 9264.93)",
    filter: "url(#np_lock_4222614_000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_lock_4222614_000000-2",
    "data-name": "np_lock_4222614_000000",
    d: "M22.911,17.159v-5.2a7.275,7.275,0,0,1,7.275-7.275v0a7.275,7.275,0,0,1,7.275,7.275v5.2h2.079a.519.519,0,0,1,.52.52V34.308a.52.52,0,0,1-.52.52H20.832a.52.52,0,0,1-.52-.52V17.679a.519.519,0,0,1,.52-.52Zm6.236,9.955a3.118,3.118,0,1,1,2.079,0v3.3a1.039,1.039,0,0,1-2.079,0Zm4.677-9.955V12.483a3.638,3.638,0,0,0-7.275,0v4.677Z",
    transform: "translate(-10.31 2.31)",
    fill: "#fff",
    stroke: "#121e59",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutline);
export default __webpack_public_path__ + "static/media/lockOutline.64df8bdc4968084bf87b0d971c7efcb8.svg";
export { ForwardRef as ReactComponent };